import {ProblemDetails} from '../types';
import {problemErrorMessages} from '../lib/problemErrors';

function buildMessage(problemDetails: ProblemDetails): string | undefined {
    // Either the service form ([{key, message}]) or the model-state form
    // ({Field: ['message']}) flattens to its messages.
    const parts: string[] = problemErrorMessages(problemDetails);

    if (parts.length === 0) {
        const outer = problemDetails.title ?? problemDetails.exception?.message;
        if (outer) {
            parts.push(outer);
        }
    }

    let inner = problemDetails.exception?.innerException;
    while (inner) {
        if (inner.message) {
            parts.push(inner.message);
        }
        inner = inner.innerException;
    }

    return parts.length > 0 ? parts.join(' -> ') : undefined;
}

export default class ProblemDetailsError extends Error {
    problemDetails: ProblemDetails;

    constructor(problemDetails: ProblemDetails) {
        super(buildMessage(problemDetails));
        this.name = 'ProblemDetailsError';
        this.problemDetails = problemDetails;
    }
}
